import { Contact, ExtendedContact, TeamInsuranceProduct } from 'types';

export function getExtendedContact(contact: Contact, teamInsuranceProducts: TeamInsuranceProduct[]): ExtendedContact {
  const contactProducts = teamInsuranceProducts
    .filter((teamInsuranceProduct) =>
      teamInsuranceProduct.contacts.some((productContact) => productContact.id === contact.id),
    )
    .map((teamInsuranceProduct) => teamInsuranceProduct.insuranceProduct);

  return {
    ...contact,
    products: contactProducts,
  };
}
